// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"461aa54d","680":"667670cb","787":"f7c64013","939":"226b84b9"}[chunkId] + ".chunk.js";
};